"use client";

import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

interface TooltipProps {
  children: React.ReactNode;
  text: string;
}

export const Tooltip = ({ children, text }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showTooltip || typeof document === "undefined") return;
    const el = triggerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const gap = 8;
    setPosition({
      top: rect.top - gap,
      left: rect.left + rect.width / 2,
    });
  }, [showTooltip]);

  const tooltipContent =
    showTooltip &&
    typeof document !== "undefined" &&
    createPortal(
      <div
        className="fixed z-[9999] w-max max-w-[300px] -translate-x-1/2 -translate-y-full"
        style={{
          top: position.top,
          left: position.left,
        }}
      >
        <div className="relative bg-black text-white text-sm rounded px-2 py-1 shadow-lg">
          {text}
          <div
            className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black"
            style={{ marginTop: -1 }}
          />
        </div>
      </div>,
      document.body,
    );

  return (
    <div
      ref={triggerRef}
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {tooltipContent}
    </div>
  );
};
